<h2 mat-dialog-title>
  {{ isEditMode ? 'Modifier la compétence' : 'Nouvelle compétence' }}
</h2>

<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="form">

    <!-- Libellé -->
    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Libellé</mat-label>
      <input matInput formControlName="libelle" placeholder="Ex: Maîtrise Spring Boot" maxlength="255">
      <mat-hint align="end">{{ form.get('libelle')?.value?.length || 0 }}/255</mat-hint>
      <mat-error *ngIf="form.get('libelle')?.hasError('required')">Champ obligatoire</mat-error>
    </mat-form-field>

    <!-- Catégorie -->
    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Catégorie</mat-label>
      <mat-select formControlName="categorieId">
        <mat-option *ngFor="let cat of categories" [value]="cat.id">
          {{ cat.nom }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('categorieId')?.hasError('required')">Champ obligatoire</mat-error>
    </mat-form-field>

    <!-- Unités organisationnelles (multi-select) -->
    <mat-form-field appearance="outline" color="accent" class="full-width">
      <mat-label>Unités organisationnelles</mat-label>
      <mat-select formControlName="unitesOrganisationnellesIds" multiple>
        <mat-option *ngFor="let uo of unitesOrganisationnelles" [value]="uo.id">
          {{ uo.code }} — {{ uo.libelle }}
        </mat-option>
      </mat-select>
      <mat-hint>Optionnel — peut être associé plus tard</mat-hint>
    </mat-form-field>

    <!-- Statut actif -->
    <div class="toggle-row">
      <span class="toggle-label">Compétence active</span>
      <mat-slide-toggle formControlName="active" color="primary"></mat-slide-toggle>
      <span class="toggle-value" [ngClass]="form.get('active')?.value ? 'text-actif' : 'text-inactif'">
        {{ form.get('active')?.value ? 'Actif' : 'Inactif' }}
      </span>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">

  <button *ngIf="isEditMode"
          mat-button
          color="warn"
          type="button"
          class="delete-btn"
          (click)="onDelete()"
          [disabled]="isSubmitting">
    <mat-icon>delete</mat-icon> Supprimer
  </button>

  <span class="spacer"></span>

  <button mat-button type="button" (click)="onCancel()">Annuler</button>

  <button mat-raised-button color="primary"
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid || isSubmitting">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ isEditMode ? 'Modifier' : 'Créer' }}
  </button>

</mat-dialog-actions>